import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate, useParams } from 'react-router-dom';

import axios from 'axios';

const RandomUserList = ({ token ,onClose }) => {
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();

    const fetchUsers = async () => {
        try {
            const response = await axios.get('/users/random', {
                headers: { Authorization: `Bearer ${token}` },
            });
            const data = response.data
            setUsers(data.users);
        } catch (error) {
            alert('사용자 정보를 불러오는데 실패했습니다');
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    return (
        <div className="Randomboard">
          <h3 className="Randomboard-title">해돋이 명소 추천</h3>
          <ul className="Randomboard-list">
            {users.map((user) => (
              <li key={user.username} className="Randomboard-item">
                <div className="Randomboard-user">
                  <img
                    src={`/assets/character/${user.avatar}`}
                    alt="Avatar"
                    className="Randomboard-avatar"
                  />
                  <div className="Randomboard-info">
                    <p className="Randomboard-username">{user.username}</p>
                  </div>
                </div>
                <button
                  className="Randomboard-button"
                  // onClick={() => navigate(`/userSun/${user.uuid}`)}
                  onClick={() => {
                    navigate(`/userSun/${user.uuid}`)
                    onClose()
                  }}
                >
                  해 보러가기
                </button>
              </li>
            ))}
          </ul>
        </div>
      );
};

export default RandomUserList;